import { http } from "~/utils/axios.util"

export type IPostNewsLetterParams = {
  mailingKey: string
  culture: string
  email: string
  firstname: string
}

export type IPostNewsletterBody = Pick<IPostNewsLetterParams, "email" | "firstname">

export type IPostNewsletterParams = Pick<IPostNewsLetterParams, "mailingKey" | "culture">

export const NewsletterRepository = {
  Post: (params: IPostNewsLetterParams) =>
    http.post<boolean>(
      "/MaileonApi/Post",
      {
        email: params.email,
        firstname: params.firstname,
      } as IPostNewsletterBody,
      {
        params: {
          mailingKey: params.mailingKey,
          culture: params.culture,
        } as IPostNewsletterParams,
      }
    ),
}
